import { increment } from "firebase/firestore";
import { REPORTS_STATS_API } from "../../constants/api";
import { useFirebase } from "../firebase/useFirebase";

export function useReportStats() {
  const { updateData } = useFirebase();

  function updateReportStats(key, value) {
    updateData(REPORTS_STATS_API, { [key]: increment(value) }, false);
  }

  return { updateReportStats };
}
